/*
 * @Author: wangshengqiang
 * @Date: 2021-10-12 17:33:53
 * @LastEditTime: 2021-10-12 17:34:57
 * @LastEditors: wangshengqiang
 * @Description: 固定模块使用，用来解决页面被固定模块挡住的问题
 */
import { useEffect } from 'react';

const useFixedUI = eleRef => {
  useEffect(() => {
    let div;

    if (eleRef.current) {
      const selfHeigth = eleRef.current.offsetHeight;
      div = document.createElement('div');
      div.style.height = `${selfHeigth}px`;
      document.body.appendChild(div);
    }

    return () => {
      div && div.remove();
    };
  }, []);
};

export default useFixedUI;